import React, { Suspense, useEffect, useState, useContext } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import LoadingSpinner from "./LoadingSpinner";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
// routes config
import routes from "../routes";
import { Tools } from "../views";
import sidebarContext from "../context/sidebar/sidebarContext";
import { Softorithm_White_Logo } from "../images";

const ToolsContent = () => {
  const loading = <LoadingSpinner />;
  const location = useLocation();
  
  // Close sidebar when tools page is opened
  const sidebarcontext = useContext(sidebarContext);
  const { setsidebarState } = sidebarcontext;

  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [showFooter, setShowFooter] = useState(true);
  useEffect(() => {
    // Check if the current route is home ("/")
    if (location.pathname.includes("tools/contractpolicy")) {
      setShowFooter(false);
    } else {
      setShowFooter(true);
    }
    
    // Close sidebar when path is exactly /tools
    if (location.pathname === "/tools") {
      setsidebarState(false);
    }
  }, [location.pathname, setsidebarState]);

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    console.log("Newsletter subscription:", newsletterEmail);
    setNewsletterEmail("");
  };
  
  // Also close sidebar on mount if on /tools
  useEffect(() => {
    if (location.pathname === "/tools") {
      setsidebarState(false);
    }
  }, []);

  return (
    <>
      <div className="Tools_Content content_wrapper">
        <Suspense fallback={loading}>
          <Routes key={location.pathname} location={location}>
            <Route path="" element={<Tools />} />
            {routes.map((route) => {
              return (
                route.element && (
                  <Route
                    key={route.name}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    element={<route.element category={route.name} />}
                  />
                )
              );
            })}
            <Route path="*" element={<Navigate to="not-found" replace />} /> 
          </Routes>
          {showFooter && (
            <>
            <footer className="py-4 mt-2 bg-dark position-relative" style={{ backgroundColor: '#181818' }}>
              <Container>
                <Row className="mb-3 justify-content-center">
                  {/* Navigation Links */}
                  <Col lg={3} md={6} className="mb-4 mb-lg-0 text-center text-lg-start">
                    <h6 className="text-white mb-3 fw-semibold">Company</h6>
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <Link to="/about" className="text-white-50 text-decoration-none">
                          About
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/blogs" className="text-white-50 text-decoration-none">
                          Blog
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/contact-us" className="text-white-50 text-decoration-none">
                          Contact
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/guest-post" className="text-white-50 text-decoration-none">
                          Guest Post
                        </Link>
                      </li>
                    </ul>
                  </Col>

                  <Col lg={3} md={6} className="mb-4 mb-lg-0 text-center text-lg-start">
                    <h6 className="text-white mb-3 fw-semibold">Who we help</h6>
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <Link to="/industries/manufactures" className="text-white-50 text-decoration-none">
                          Manufactures
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/industries/wholesalers" className="text-white-50 text-decoration-none">
                          Wholesalers
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/industries/distributors" className="text-white-50 text-decoration-none">
                          Distributors
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/industries/retailers" className="text-white-50 text-decoration-none">
                          Retailers
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/industries/restaurants" className="text-white-50 text-decoration-none">
                          Restaurants
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/industries/super-marts" className="text-white-50 text-decoration-none">
                          Super Marts
                        </Link>
                      </li>
                    </ul>
                  </Col>

                  <Col lg={3} md={6} className="mb-4 mb-lg-0 text-center text-lg-start">
                    <h6 className="text-white mb-3 fw-semibold">What we do</h6>
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <Link to="/services/erp-business-software" className="text-white-50 text-decoration-none">
                          ERP Business Software
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/services/web-design" className="text-white-50 text-decoration-none">
                          Web Design
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/services/web-development" className="text-white-50 text-decoration-none">
                          Web Development
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/services/digital-marketing" className="text-white-50 text-decoration-none">
                          Digital Marketing
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/services/web-application-development" className="text-white-50 text-decoration-none">
                          Web App Development
                        </Link>
                      </li>
                      <li className="mb-2">
                        <Link to="/services/video-editing-marketing" className="text-white-50 text-decoration-none">
                          Video Editing Marketing
                        </Link>
                      </li>
                    </ul>
                  </Col>

                  {/* Company Branding and Contact Information */}
                  <Col lg={3} md={6} className="text-center text-lg-start">
                    <div className="mb-3 d-flex justify-content-center justify-content-lg-start">
                      <img 
                        src={Softorithm_White_Logo} 
                        alt="Company Logo" 
                        style={{ maxWidth: '200px', height: 'auto', marginBottom: '15px' }}
                      />
                    </div>
                    <div className="contact-info">
                      <div className="mb-2 d-flex align-items-center justify-content-center justify-content-lg-start">
                        <i className="ri-mail-line text-white me-2"></i>
                        <a href="mailto:support@softorithm.com" className="text-white text-decoration-none">
                          support@softorithm.com
                        </a>
                      </div>
                      <div className="mb-3 d-flex align-items-center justify-content-center justify-content-lg-start">
                        <i className="ri-phone-line text-white me-2"></i>
                        <a href="tel:+923338469166" className="text-white text-decoration-none">
                          +92 333 8469166
                        </a>
                      </div>
                      <div className="social-icons d-flex gap-2 justify-content-center justify-content-lg-start">
                        <a href="https://youtube.com/@softorithm" target="_blank" rel="noopener noreferrer" className="text-white">
                          <i className="ri-youtube-fill" style={{ fontSize: '20px' }}></i>
                        </a>
                        <a href="https://facebook.com/softorithm" target="_blank" rel="noopener noreferrer" className="text-white">
                          <i className="ri-facebook-fill" style={{ fontSize: '20px' }}></i>
                        </a>
                        <a href="https://instagram.com/softorithm" target="_blank" rel="noopener noreferrer" className="text-white">
                          <i className="ri-instagram-line" style={{ fontSize: '20px' }}></i>
                        </a>
                        <a href="https://tiktok.com/@softorithm" target="_blank" rel="noopener noreferrer" className="text-white">
                          <i className="ri-tiktok-fill" style={{ fontSize: '20px' }}></i>
                        </a>
                        <a href="https://linkedin.com/company/softorithm" target="_blank" rel="noopener noreferrer" className="text-white">
                          <i className="ri-linkedin-fill" style={{ fontSize: '20px' }}></i>
                        </a>
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* Newsletter Subscription Section */}
                <Row className="mb-3">
                  <Col lg={12} className="d-flex justify-content-center">
                    <div style={{ backgroundColor: '#00d4aa', padding: '15px 20px', borderRadius: '4px', width: '100%', maxWidth: '80%' }}>
                      <div className="d-flex align-items-center justify-content-between flex-wrap" style={{ gap: '15px' }}>
                        <h5 className="text-white mb-0 fw-semibold">Get Latest Updates</h5>
                        <form onSubmit={handleNewsletterSubmit} className="d-flex flex-wrap gap-2" style={{ flex: '1 1 250px', maxWidth: '600px' }}>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Enter Your Email"
                            value={newsletterEmail}
                            onChange={(e) => setNewsletterEmail(e.target.value)}
                            required
                            style={{ flex: '1 1 150px', minWidth: '0' }}
                          />
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ backgroundColor: '#2ca876', color: 'white', border: 'none', padding: '8px 24px', whiteSpace: 'nowrap' }}
                          >
                            Subscribe
                          </button>
                        </form>
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* Copyright and Policy Links */}
                <Row>
                  <Col lg={12}>
                    <div className="d-flex flex-wrap align-items-center justify-content-center gap-3 py-2 border-top border-secondary">
                      <span className="text-white-50">
                        © Copyright 2026 by Softorithm
                      </span>
                      <Link to="#" className="text-white-50 text-decoration-none">
                        Privacy Policy
                      </Link>
                      <Link to="#" className="text-white-50 text-decoration-none">
                        Sitemap
                      </Link>
                      <Link to="#" className="text-white-50 text-decoration-none">
                        Terms & Conditions
                      </Link>
                    </div>
                  </Col>
                </Row>
              </Container>
            </footer>
            </>
          )}
        </Suspense>
      </div>
    </>
  );
};

export default ToolsContent;
